// extracted by mini-css-extract-plugin
export var affiliate = "SignUpForm-module--affiliate--f8e4f";
export var ageAlert = "SignUpForm-module--ageAlert--6abfc";
export var button = "SignUpForm-module--button--16393";
export var checkboxGutter = "SignUpForm-module--checkboxGutter--66112";
export var collapsedAddress = "SignUpForm-module--collapsedAddress--fb993";
export var continueButton = "SignUpForm-module--continueButton--dfc75";
export var emailWrapper = "SignUpForm-module--emailWrapper--92cb8";
export var emptyAddress = "SignUpForm-module--emptyAddress--f81dd";
export var footer = "SignUpForm-module--footer--3000e";
export var inlineExistingAccount = "SignUpForm-module--inlineExistingAccount--84541";
export var input = "SignUpForm-module--input--f0e7c";
export var label = "SignUpForm-module--label--7906d";
export var lock = "SignUpForm-module--lock--62c94";
export var loginEmail = "SignUpForm-module--loginEmail--95bb1";
export var nationality = "SignUpForm-module--nationality--953c0";
export var twoColumn = "SignUpForm-module--twoColumn--b531e";
export var wrongAddress = "SignUpForm-module--wrongAddress--d291e";